class Slider {
  constructor() {
    document.querySelectorAll(".op-slider").forEach(slider => this.new_slider(slider))
  }

  new_slider($slider) {
    const track = $slider.querySelector(".op-slider__track")
    const nextButton = $slider.querySelector(".control--next")
    const prevButton = $slider.querySelector(".control--prev")
    const imgInfo = $slider.querySelector(".op-slider__image-info")
    const slides = Array.from(track.children) 

    // Get info of first image and display it in slide info section
    slides[0].classList.add('current-slide');
    imgInfo.innerHTML = slides[0].dataset.info;

    // Position All Slies
    let slideOffset = slides[0].getBoundingClientRect().width;
    slides.forEach((slide) => {
      if (slide.nextElementSibling) {
        let nextSlide = slide.nextElementSibling;
        nextSlide.style.transform = `translateX(${slideOffset}px)`;
        slideOffset += nextSlide.getBoundingClientRect().width;
      }
    });

    // Get the position of last Slide and exctract number
    let lastSlidePos = slides[slides.length - 1].style.transform.replace(
      /[^\d.]/g,
      ""
    );

    // Slides Navigation
    let trackOffset = 0;
    nextButton.addEventListener("click", () => {
      let currentSlide = track.querySelector(".current-slide");

      if (currentSlide.nextElementSibling) {
        const slideWidth = currentSlide.getBoundingClientRect().width;
        const nextSlide = currentSlide.nextElementSibling;

        trackOffset += slideWidth;
        track.style.transform = `translateX(-${trackOffset}px)`;

        currentSlide.classList.remove("current-slide");
        nextSlide.classList.add("current-slide");
      } else {
        track.style.transform = `translateX(0px)`;
        currentSlide.classList.remove("current-slide");
        slides[0].classList.add("current-slide");
        trackOffset = 0;
      }
      // Display Slide Info
      currentSlide = track.querySelector(".current-slide");
      imgInfo.innerHTML = currentSlide.dataset.info;
    });

    prevButton.addEventListener("click", () => {
      let currentSlide = track.querySelector(".current-slide");

      if (currentSlide.previousElementSibling) {
        const previousSlide = currentSlide.previousElementSibling;
        const previousSlideWidth = previousSlide.getBoundingClientRect().width;

        trackOffset -= previousSlideWidth;
        track.style.transform = `translateX(-${trackOffset}px)`;

        currentSlide.classList.remove("current-slide");
        previousSlide.classList.add("current-slide");
      } else {
        track.style.transform = `translateX(-${lastSlidePos}px)`;
        currentSlide.classList.remove("current-slide");
        slides[slides.length - 1].classList.add("current-slide");
        trackOffset = lastSlidePos;
      }
      // Display Slide Info
      currentSlide = track.querySelector(".current-slide");
      imgInfo.innerHTML = currentSlide.dataset.info;
    });

  } 
}
export default Slider
